import { Link } from "react-router-dom";

const AutoClub = () => {
  return (
    <section>
      <div className="container-fluid">
        <div className="row">
         

          <div className="col-lg-10 mt-3 mb-3">
            <div className="row">
              <div className="col-lg-1 text-end">
                <Link to="/">
                  <h6>
                    <i class="fa fa-home" aria-hidden="true"></i>Home
                  </h6>
                </Link>
              </div>
              /
              <div className="col-lg-5">
                <h6>Auto Club Details</h6>
              </div>
            </div>

            <div className="row">
              <div className="card border-0 shadow ">
                <div className="card-header bg bg-info border-0">
                  <h4>Auto Club Details</h4>
                </div>

                <div className="card-body text-center">
                  <div className="col-lg-10 ">
                    <div className="row ">
                      {/* =======================table start================= */}

                      <div className="col-lg-12 mt-3">
                        <div class="table-responsive">
                          <table class="table table-bordered  mb-0 text-nowrap">
                            <thead>
                              <tr class="bg-primary">
                                <th> Sl.No </th>
                                <th> Club </th>
                                <th> Members </th>
                                <th> Amount </th>
                                <th> Status </th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td class="text-dark"> 01 </td>
                                <td>
                                  <div class="badge badge-success">Club 1</div>
                                </td>
                                <td> 100 </td>
                                <td> 5000 </td>
                                <td>
                                  
                                  <button
                                    onclick="location.href = 'club-single-details.html';"
                                    type="button"
                                    class="btn btn-sm btn-warning"
                                  >
                                    View Details
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* =======================table end================= */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AutoClub;
